const machineRoles = {
	NONE: 'none',
	POWER: 'power',
	STORAGE: 'storage',
	PRODUCTION: 'production',
	DELIVERY: 'delivery'
};

export default machineRoles;